module.exports = __webpack_public_path__ + "img/banner.68d91b10.png";